<template>
    <div>
    <h3>Door Notes</h3>
        <div class="stylesoption">
            <div class="form-group">
                <textarea v-model="localTarget" class="form-control" id="notes" rows="10" placeholder="Please note if additional items are added to this field your price is subject to change"></textarea>
                <span id="remain" class="small">{{ limit_input }}</span> characters remaining
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        emits: ['update:target'],
        props: {
            title: {
                default(){
                    return 'Notes:';
                }
            },
            target: {
                default: ''
            },
            max_char: {
                default: 255
            }
        },
        computed: {
            localTarget: {
                get() {
                    return this.target
                },
                set(val) {
                    if(this.target !== val) {
                        this.$emit('update:target', val)
                    }
                }
            },
            limit_input(){
                if (this.localTarget == null) {
                    return 0;
                }
                if (this.localTarget.length >= this.max_char) {
                    $('#notes').val($('#notes').val().substring(0, this.max_char));
                }
                if (this.max_char - this.localTarget.length < 1) {
                    return 0;
                }
                return this.max_char - this.localTarget.length;
            },
            cache_key(){
                return '_';
            },
        },
      watch: {
        'localTarget': {
          handler: window._.debounce(function () {
            this.localTarget = this.localTarget.replace(/[^a-zA-Z0-9.]+/g," ");
          }, 50),
        }
      },
    }
</script>
